(() => {
  'use strict';
  const origin = 'https://www.green24.de';
  const marker = document.querySelector('script[data-g24-locale-guard="de"]');
  if (!marker || location.origin !== origin || document.documentElement.lang !== 'de' || /^\/en(?:\/|$)/.test(location.pathname)) return;
  if (window.Green24DeLocaleGuard) return;

  const attributes = ['href', 'action', 'formaction', 'data-url', 'data-product-url'];
  const selector = 'a[href],area[href],form[action],button[formaction],input[formaction],[data-url],[data-product-url]';
  const languageControls = 'localization-form,.localization-form,[data-localization-form],[data-language-selector],[data-country-selector],[data-locale-switch],[data-g24-allow-locale-change],a[hreflang],area[hreflang],a[lang],area[lang],[rel~="alternate"]';
  const routeKeys = ['root_url', 'cart_url', 'cart_add_url', 'cart_change_url', 'cart_update_url', 'cart_clear_url', 'search_url', 'predictive_search_url'];

  function normalize(value) {
    if (typeof value !== 'string') return value;
    const raw = value.trim();
    if (!raw || raw.startsWith('#') || /^(?:mailto|tel|javascript|data):/i.test(raw)) return value;
    let url;
    try { url = new URL(raw, document.baseURI); } catch (_) { return value; }
    if (url.username || url.password) return value;
    if (url.origin === 'https://shopify.com' && /^\/97228685696\/account\/?$/.test(url.pathname) && url.searchParams.getAll('locale').length === 1 && url.searchParams.get('locale') === 'en') {
      const hashAt = value.indexOf('#');
      const head = hashAt < 0 ? value : value.slice(0, hashAt);
      const hash = hashAt < 0 ? '' : value.slice(hashAt);
      return head.replace(/([?&])locale=en(?=&|$)/, '$1locale=de') + hash;
    }
    if (url.origin !== origin) return value;
    for (const key of ['locale', 'language', 'language_code']) {
      const choice = url.searchParams.get(key);
      if (choice && choice.toLowerCase() !== 'de') return value;
    }
    if (!/^\/en(?:\/?$|\/(?:collections|products|pages|blogs|policies|search|cart)(?:\/|(?:\.js|\.json)?$))/.test(url.pathname)) return value;
    const path = url.pathname.slice(3) || '/';
    const target = path + url.search + url.hash;
    if (/^https?:\/\//i.test(raw)) return url.origin + target;
    if (raw.startsWith('//')) return '//' + url.host + target;
    return target;
  }

  function protectedElement(element) {
    if (element.closest(languageControls)) return true;
    if (element.matches('a[href],area[href]') && /^(?:English|Englisch|EN)$/i.test((element.getAttribute('aria-label') || element.textContent || '').trim())) return true;
    const form = element instanceof HTMLFormElement ? element : element.closest('form');
    if (!form) return false;
    if (/\/(?:[a-z]{2}\/)?localization\/?(?:[?#]|$)/.test(form.getAttribute('action') || '')) return true;
    return Boolean(form.querySelector('[name="language_code"],[name="locale"],[name="country_code"]'));
  }

  function repairElement(element) {
    if (!(element instanceof Element) || !element.matches(selector) || protectedElement(element)) return;
    for (const name of attributes) {
      if (name === 'href' && !element.matches('a,area')) continue;
      if (name === 'action' && !element.matches('form')) continue;
      if (name === 'formaction' && !element.matches('button,input')) continue;
      const before = element.getAttribute(name);
      if (before === null) continue;
      const after = normalize(before);
      if (after !== before) element.setAttribute(name, after);
    }
  }

  function repairTree(root) {
    if (root instanceof Element) repairElement(root);
    if (root.querySelectorAll) root.querySelectorAll(selector).forEach(repairElement);
  }

  function repairRoutes() {
    if (window.Shopify && window.Shopify.routes && typeof window.Shopify.routes.root === 'string') {
      const before = window.Shopify.routes.root;
      const after = normalize(before);
      if (after !== before) { try { window.Shopify.routes.root = after; } catch (_) {} }
    }
    if (!window.routes || typeof window.routes !== 'object') return;
    for (const key of routeKeys) {
      const before = window.routes[key];
      if (typeof before !== 'string') continue;
      const after = normalize(before);
      if (after !== before) { try { window.routes[key] = after; } catch (_) {} }
    }
  }

  function refresh() { repairRoutes(); repairTree(document); }
  function beforeInteraction(event) {
    repairRoutes();
    if (!(event.target instanceof Element)) return;
    const target = event.target.closest('a[href],area[href],form,button[formaction],input[formaction],product-info,variant-selects');
    if (target) repairTree(target);
    if (event.submitter) repairElement(event.submitter);
  }

  window.Green24DeLocaleGuard = Object.freeze({ version: '2026-09-29.1', language: 'de' });
  const observer = new MutationObserver(records => {
    repairRoutes();
    const repairedAttributes = new Set();
    const repairedTrees = new Set();
    for (const record of records) {
      if (record.type === 'attributes') {
        if (!repairedAttributes.has(record.target)) {
          repairedAttributes.add(record.target);
          repairElement(record.target);
        }
      } else {
        record.addedNodes.forEach(node => {
          if (!repairedTrees.has(node)) {
            repairedTrees.add(node);
            repairTree(node);
          }
        });
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: attributes });
  for (const type of ['click', 'submit', 'input', 'change']) document.addEventListener(type, beforeInteraction, true);
  document.addEventListener('shopify:section:load', event => { repairRoutes(); repairTree(event.target); });
  document.addEventListener('DOMContentLoaded', repairRoutes, { once: true });
  window.addEventListener('pageshow', event => { if (event.persisted) refresh(); });
  window.addEventListener('load', repairRoutes, { once: true });
  refresh();
})();
